import React, { useCallback } from "react";
import moment from "moment/min/moment-with-locales";
import ReportingService from "Lib/API/reporting";
import useWidgetData from "./useWidgetData";
import WidgetWrapper from "./WidgetWrapper";
import "./widgets.scss";


const AnniversariesWidget = ({ customizeMode, onRemove }) => {
  const fetcher = useCallback((token) => ReportingService.getWidgetAnniversaries(token), []);
  const { data, loading, error, retry } = useWidgetData(fetcher);

  const items = data?.upcoming || [];

  return (
    <WidgetWrapper
      title="Upcoming Anniversaries"
      loading={loading}
      error={error}
      onRetry={retry}
      customizeMode={customizeMode}
      onRemove={onRemove}
    >
      {items.length === 0 ? (
        <div className="list-widget__empty list-widget__empty--good">
          No anniversaries in the next 30 days
        </div>
      ) : (
        <div className="widget-scroll-list" style={{ maxHeight: 400 }}>
          {items.slice(0, 8).map((item, i) => {
            const mon = moment(item.date).format("MMM");
            const day = moment(item.date).format("D");
            const isToday = item.daysUntil === 0;
            const dayPill = isToday ? "Today" : item.daysUntil === 1 ? "Tomorrow" : `${item.daysUntil}d`;
            return (
              <div key={i} className="yahr-row">
                <div className="yahr-date">
                  <div className="yahr-date__month">{mon}</div>
                  <div className="yahr-date__day">{day}</div>
                </div>
                <div className="yahr-info">
                  <div className="yahr-info__name">{item.name || "—"}</div>
                  {item.familyName ? (
                    <div className="yahr-info__rel">{item.familyName}</div>
                  ) : null}
                </div>
                <div className={`yahr-days${isToday ? " yahr-days--today" : " yahr-days--anniv"}`}>
                  {dayPill}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </WidgetWrapper>
  );
};

export default AnniversariesWidget;
